import React from 'react';

const BootstrapContext = React.createContext({});

export const BootstrapContextProvider = BootstrapContext.Provider;
export const BootstrapConsumer = BootstrapContext.Consumer;
export default BootstrapContext;
